<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="calendarVisible" width="25%" custom-class="dialogPaddingTop0" :title="nowOption=='new'?$t('new_calendar'):$t('edit_calendar')">
      <el-form
        ref="form"
        :model="detail"
        label-position="top"
        size="mini">
        
        <div style="height:10px"></div>
        
        <el-row :gutter="24" >
          <el-col :span="20">
            <el-form-item :label="$t('from_calendar')" class="padding0Label">
              <el-select v-model="content._calendarid"  :placeholder="$t('placeholder_select')" style="width:100%" :disabled="nowOption=='change'?true:false">
                <el-option
                  v-for="cld in calendars.datas"
                  :key="cld.id"
                  :label="cld.name"
                  :value="cld.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          
          <el-col :span="20">
            <el-form-item :label="$t('copy_calendar')"  class="padding0Label">
              <el-input type="text" v-model="content.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="20">
            <el-form-item :label="$t('description')"  class="padding0Label">
              <el-input type="textarea" :rows="1" v-model="content.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row>
          <el-col :span="24" style="text-align:right">
            <span class="toolbar-buttons">
              <el-button type="primary" plain @click="onCancleBtnClick" size="small">{{$t('cancel')}}</el-button>
              <el-button type="primary" @click="onCheckBtnClick" size="small">{{$t('confirm')}}</el-button>
            </span>
          </el-col>
        </el-row>
      </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["visible","detail","nowOption"],

  created() {
    this.content={
      name:this.detail.name,
      _calendarid:this.detail.fromCalendarId ? this.detail.fromCalendarId:this.detail.id,
      remark:this.detail.remark,
    };
      this.$api.getDomainCalendars(
        { domainid: this.$route.query.domainid,currpage: 1, pagelines: 10,data:{ name: "", }},
        {
          onSucess: resp => {
            this.calendars = resp.data.data;
            this.content._calendarid=this.calendars[0].id
          }
        }
      );
  },
  
  computed: {
    calendarVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  watch:{
    detail(newVal){
        this.content=JSON.parse(JSON.stringify(newVal))
      
    },
    
  },
  data() {
    return {
      calendars: [],
      content:{
        name:"",
        _calendarid:"",
        remark:"",
      },
      calendarType:"",
      contentPre:{},
    };
  },
  methods:{
    onCheckBtnClick(){
      if(this.detail.id){
        for(let i=0;i<this.calendars.datas.length;i++){
          if(this.content.name==this.calendars.datas[i].name &&this.detail.id !==this.calendars.datas[i].id){
            this.$message({
              showClose: true,
              message: this.$t('msg_calendar_exist'),
              type: "error"
            });
            return false;
          }
        }
        this.$api.updataCalendars(this.$route.query.domainid,this.content.id, this.content,
        {
          onSucess: resp => {
            if (resp.data.errcode == 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('msg_save_success'),
                  type: "success"
                });
                this.calendarVisible=false;
                this.$emit("new-ok");
              } else {
                this.$message({
                  showClose: true,
                  message: resp.data.errmsg,
                  type: "error"
                });
              }
          }
        }
      );
      }else{
        if(this.content.name==""||!this.content.name){
          this.$message({
            showClose: true,
            message: this.$t('msg_require_calendarName'),
            type: "error"
          });
          return false;
        }else{
          for(let i=0;i<this.calendars.datas.length;i++){
            if(this.content.name==this.calendars.datas[i].name){
              this.$message({
                showClose: true,
                message: this.$t('msg_calendar_exist'),
                type: "error"
              });
              return false;
            }
          }
        }
        this.$api.newCalendars(this.$route.query.domainid, this.content,
          {
            onSucess: resp => {
              if (resp.data.errcode == 0) {
                  this.$message({
                    showClose: true,
                    message: this.$t('msg_new_success'),
                    type: "success"
                  });
                  this.calendarVisible=false;
                  this.$emit("new-ok");
                } else {
                  this.$message({
                    showClose: true,
                    message: resp.data.errmsg,
                    type: "error"
                  });
                }
            }
          }
        );
      }
      
    },
    onCancleBtnClick(){
      this.calendarVisible=false;
      this.$emit("new-ok");
    },
  }

};
</script>

<style>
</style>